import { render, staticRenderFns } from "./SimpleCustomerSearchList.vue?vue&type=template&id=5ed8a602&"
import script from "./SimpleCustomerSearchList.vue?vue&type=script&lang=js&"
export * from "./SimpleCustomerSearchList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports